import React, { createContext, useContext, useState, useEffect } from 'react';
import apiService from '../services/api';

const LocationContext = createContext();

export const LocationProvider = ({ children }) => {
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Load locations on mount
  useEffect(() => {
    loadLocations();
  }, []);

  const loadLocations = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await apiService.locations.getAll();
      setLocations(data);
      
      // Load saved location from localStorage or select first active location
      const savedLocationId = localStorage.getItem('selectedLocationId');
      if (savedLocationId) {
        const savedLocation = data.find(loc => loc.id === parseInt(savedLocationId));
        if (savedLocation && savedLocation.is_active) {
          setSelectedLocation(savedLocation);
        } else {
          // Select first active location if saved location is not valid
          const activeLocation = data.find(loc => loc.is_active);
          setSelectedLocation(activeLocation || data[0]);
        }
      } else {
        // Select first active location by default
        const activeLocation = data.find(loc => loc.is_active);
        setSelectedLocation(activeLocation || data[0]);
      }
    } catch (err) {
      console.error('Error loading locations:', err);
      setError('Failed to load locations');
      
      // Fallback to mock data if API fails
      const fallbackLocations = [
        {
          id: 1,
          name: 'Madhapur',
          address: '1-103/1 Hitec City, Main Road, Madhapur, Hyderabad',
          city: 'Hyderabad',
          phone: '+91 8121034991',
          is_active: true,
        },
        {
          id: 2,
          name: 'Banjara Hills',
          address: 'Road No 12, Film City, Dream Valley, Banjara Hills, Hyderabad',
          city: 'Hyderabad',
          phone: '+91 8121035492',
          is_active: true,
        },
        {
          id: 3,
          name: 'Kondapur',
          address: 'Survey No 83, Ground Floor, Plot No 83, opposite KPHB Colony, Kondapur',
          city: 'Hyderabad',
          phone: '+91 8121035493',
          is_active: true,
        }
      ];
      setLocations(fallbackLocations);
      setSelectedLocation(fallbackLocations[0]);
    } finally {
      setLoading(false);
    }
  };

  const changeLocation = (location) => {
    // Create new object reference to ensure useEffect hooks trigger
    setSelectedLocation({ ...location });
    localStorage.setItem('selectedLocationId', location.id);
    console.log('📍 Location changed to:', location.name, '(ID:', location.id, ')');
  };

  return (
    <LocationContext.Provider value={{
      locations,
      selectedLocation,
      loading,
      error,
      changeLocation,
      reloadLocations: loadLocations,
    }}>
      {children}
    </LocationContext.Provider>
  );
};

export const useLocation = () => {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error('useLocation must be used within a LocationProvider');
  }
  return context;
};
